export const SELECTOR_VAT_EU_CHECKBOX = '#input_vat_eu'
export const COMPANY_ID = 2;
export const POLAND_COUNTRY_ID = 179;